import { ColourSwatchProps } from "../../data-models/props";
import { useStoreState } from "../../store/data-store";

const ColourSwatch = ( {colourNumber, rgb}:ColourSwatchProps) => {

    const colours = useStoreState(store => store.colours);

    if( rgb === undefined ){
        const colour = colours.find(x => x.colourNumber.toLocaleUpperCase() === colourNumber?.toLocaleUpperCase());
        rgb = colour?.rgb;
    }

    const invalidDisplay = rgb === "invalid" ? "X" : "";

    return (
        <div className='colour-swatch' style={{ backgroundColor: `${rgb}` }}>{invalidDisplay}</div>
    )

}
export default ColourSwatch;